<ng-container *transloco="let translate">
    <ng-container *ngFor="let subSection of subSections">
        <div [ngClass]="subSection.styles?.container" *ngIf="!hideSubSection(subSection, record, subSectionRecord)">
            <ng-container *ngIf="subSection?.displayName && subSection?.displayName.length > 0">
                <div class="subSectionDisplayName" [ngClass]="subSection.styles?.displayName">
                    {{ translate(subSection.displayName) }}
                    <div class="subSectionActionsContainer">
                        <div class="subSectionActionContainer" *ngIf="subSection?.canAddRecord && !readonly">
                            <mat-icon *ngIf="subSection?.records?.length < sources.length" [title]="translate('Add New Record')" (click)="addNewSubSectionRecord(subSection)">add</mat-icon>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngTemplateOutlet="integrationSubSections; context: { record: record, subSection: subSection, subSectionRecord: subSectionRecord }"></ng-container>
        </div>
    </ng-container>

    <ng-template #integrationSubSections let-record="record" let-subSection="subSection" let-subSectionRecord="subSectionRecord">
        <ng-container *ngIf="!hideSubSection(subSection, record, subSectionRecord)">
            <ng-container [ngSwitch]="subSection.structure">
                <ng-container *ngSwitchCase="'RECORDS_FORM'">
                    <ng-container *ngTemplateOutlet="recordsStructure; context: { record: record, subSection: subSection }"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'RECORD_FORM'">
                    <ng-container *ngTemplateOutlet="recordsStructure; context: { record: record, subSection: subSection }"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'POSTMAN'">
                    <ng-container *ngTemplateOutlet="postManStructure; context: { record: record, subSection: subSection, subSectionRecord: subSectionRecord }"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'POSTMAN_NEW'">
                    <ng-container *ngTemplateOutlet="postManStructure; context: { record: record, subSection: subSection, subSectionRecord: subSectionRecord }"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'FORM'">
                    <ng-container *ngTemplateOutlet="formStructure; context: { record: record, subSection: subSection }"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'FLEX_FORM'">
                    <ng-container *ngTemplateOutlet="flexFormStructure; context: { record: record, subSection: subSection }"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'HTTP'">
                    <ng-container *ngTemplateOutlet="httpStructure; context: { record: record, subSection: subSection, subSectionRecord: subSectionRecord }"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'TABLE'">
                    <app-integration-table-stucture [tab]="$any(subSection)" [record]="record" [masterTableColumns]="masterTableColumns" [masterTables]="masterTables" [subTenants]="subTenants" (checkValidateButton)="checkValidateButton.emit($event)"></app-integration-table-stucture>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-template>

    <ng-template #recordsStructure let-record="record" let-subSection="subSection">
        <ng-container *ngTemplateOutlet="subSection.array ? recordsArrayStructure : recordsFormStructure; context: { record: record, subSection: subSection }"></ng-container>
    </ng-template>

    <ng-template #recordsArrayStructure let-record="record" let-subSection="subSection">
        <div *ngFor="let subSectionRecord of subSection.records; let i = index" [class.even]="i % 2 === 1" [class.odd]="i % 2 === 0" [class.subSectionRecordContainer]="!subSection.useAccordion" [class.my-3]="subSection.useAccordion">
            <ng-container *ngIf="subSection.useAccordion">
                <material-accordion [showFooter]="false" [showContentOnlyOnExpand]="true">
                    <div class="materialAccordionHeader">
                        {{ getFieldValue(subSectionRecord, subSection.accordionHeaderFieldId) || 'Api Name' }}
                    </div>
                    <div class="materialAccordionBody p-2">
                        <ng-container *ngTemplateOutlet="recordsArrayStructureDisplay; context: { record: record, subSection: subSection, subSectionRecord: subSectionRecord, i: i }"></ng-container>
                    </div>
                </material-accordion>
            </ng-container>
            <ng-container *ngIf="!subSection.useAccordion">
                <ng-container *ngTemplateOutlet="recordsArrayStructureDisplay; context: { record: record, subSection: subSection, subSectionRecord: subSectionRecord, i: i }"></ng-container>
            </ng-container>
        </div>
        <div class="text-right mb-2" *ngIf="subSection.useAccordion && subSection.array && subSection.canAddRecord && !readonly">
            <span class="inline-block">
                <material-button *ngIf="inConnectorsUI" class="deleteButton" [text]="translate('Add')" [color]="'primary'" (buttonClicked)="addNewSubSectionRecord(subSection)"></material-button>
            </span>
        </div>
    </ng-template>

    <ng-template #recordsArrayStructureDisplay let-record="record" let-subSection="subSection" let-subSectionRecord="subSectionRecord" let-i="i">
        <div>
            <span class="removeSubRecordAction actionsAtTop !right-[100px] z-10" *ngIf="!subSection.useAccordion && subSection.canAddRecord">
                <material-button *ngIf="inConnectorsUI && !readonly" class="deleteButton" [text]="translate('Add')" [color]="'primary'" (buttonClicked)="addNewSubSectionRecord(subSection)"></material-button>
            </span>
            <span class="removeSubRecordAction actionsAtTop z-10">
                <material-button *ngIf="!readonly" class="deleteButton" [text]="translate('Delete')" [color]="'default'" [suffixIcon]="'delete'" (buttonClicked)="deleteSubRecord(subSection.records, i)"></material-button>
            </span>
            <span class="removeSubRecordAction actionsAtBottom">
                <material-button *ngIf="subSectionRecord && canShowTestConnection(subSectionRecord) && !inConnectorsUI" [text]="translate('Test Connection')" [color]="'primary'" (buttonClicked)="testConnection.emit({record, index: i})"></material-button>
            </span>
            <div [ngClass]="subSection.styles?.fieldsContainer">
                <ng-container *ngIf="subSection?.subDisplayName && subSection?.subDisplayName.length > 0">
                    <div class="subSectionDisplayName" [ngClass]="subSection.styles?.subDisplayName">
                        {{ translate(subSection.subDisplayName) }}
                        <div class="subSectionActionsContainer">
                            <div class="subSectionActionContainer" *ngIf="subSection?.canAddRecord && !readonly">
                                <mat-icon *ngIf="subSection?.records?.length < sources.length" [title]="translate('Add New Record')" (click)="addNewSubSectionRecord(subSection)">add</mat-icon>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="subSectionRecord.fields && subSectionRecord.fields.length > 0">
                    <div class="subSectionRecordFieldsContainer row">
                        <ng-container *ngFor="let field of subSectionRecord.fields">
                            <div class="inboundIntegrationFieldContainer" *ngIf="!hideField(field, record, undefined, subSectionRecord) && field.show !== false" [ngClass]="(field?.informationSnippetType?.length > 0 ? 'flex justify-between w-full gap-4 px-[15px]' : 'col-4')">
                                <ng-container *ngTemplateOutlet="integrationField; context: { record: record, field: field, subSectionRecord: subSectionRecord, hide: field.hide }"></ng-container>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
            <ng-container *ngIf="subSection.hasChildSubSectons">
                <ng-container *ngTemplateOutlet="subsectionsStructure; context: { record: record, subSections: subSectionRecord.childSubSections, subSectionRecord: subSectionRecord }"></ng-container>
            </ng-container>
        </div>
    </ng-template>

    <ng-template #recordsFormStructure let-record="record" let-subSection="subSection">
        <ng-container *ngIf="subSection.useAccordion">
            <material-accordion [showFooter]="false" [showContentOnlyOnExpand]="true">
                <div class="materialAccordionHeader">
                    {{ getFieldValue(subSection, subSection.accordionHeaderFieldId) || 'Api Name' }}
                </div>
                <div class="materialAccordionBody p-2">
                    <ng-container *ngTemplateOutlet="recordStructureDisplay; context: { record: record, subSection: subSection }"></ng-container>
                </div>
            </material-accordion>
        </ng-container>
        <ng-container *ngIf="!subSection.useAccordion">
            <ng-container *ngTemplateOutlet="recordStructureDisplay; context: { record: record, subSection: subSection }"></ng-container>
        </ng-container>
    </ng-template>

    <ng-template #recordStructureDisplay let-record="record" let-subSection="subSection">
        <div>
            <ng-container *ngIf="subSection.fields?.length > 0">
                <div class="subSectionRecordFieldsContainer row">
                    <ng-container *ngFor="let field of subSection.fields">
                        <div class="inboundIntegrationFieldContainer" [ngClass]="(field?.informationSnippetType?.length > 0 ? 'flex justify-between w-full gap-4 px-[15px]' : 'col-4')" *ngIf="!hideField(field, record, subSection) && field.show !== false">
                            <ng-container *ngTemplateOutlet="integrationField; context: { record: record, field: field, subSectionRecord: subSection, hide: field.hide }"></ng-container>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="subSection.hasChildSubSectons">
                <ng-container *ngTemplateOutlet="subsectionsStructure; context: { record: record, subSections: subSection.childSubSections }"></ng-container>
            </ng-container>
        </div>
    </ng-template>

    <ng-template #postManStructure let-record="record" let-subSection="subSection" let-subSectionRecord="subSectionRecord">
        <app-integrations-postman-structure [readonly]="readonly" [sources]="sources" [subTenants]="subTenants" [masterTables]="masterTables" [record]="record" [subSection]="subSection" [hideField]="hideField" [subSectionRecord]="subSectionRecord" [masterTableColumns]="masterTableColumns" (checkValidateButton)="checkValidateButton.emit($event)"></app-integrations-postman-structure>
    </ng-template>

    <ng-template #formStructure let-record="record" let-subSection="subSection">
        <div class="row">
            <ng-container *ngIf="subSection.fields && subSection.fields.length > 0">
                <ng-container *ngFor="let field of subSection.fields; let i = index">
                    <ng-container *ngIf="!hideField(field, record) && field.show !== false">
                        <div class="inboundIntegrationFieldContainer col-6">
                            <ng-container *ngTemplateOutlet="integrationField; context: { record: record, field: field, hide: hideField(field, record) }"></ng-container>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </ng-template>

    <ng-template #flexFormStructure let-record="record" let-subSection="subSection">
        <div class="flexFormContainer">
            <ng-container [ngSwitch]="subSection.id">
                <ng-container *ngSwitchCase="'schedulerExpression'">
                    <ng-container *ngFor="let field of subSection.fields; let i = index">
                        <cron-editor [(cron)]="field.value" [options]="cronOptions" [disabled]="readonly"></cron-editor>
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'cronExpression'">
                    <ng-container *ngFor="let field of subSection.fields; let i = index">
                        <cron-editor [(cron)]="field.value" [options]="cronOptions" [disabled]="readonly"></cron-editor>
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <ng-container *ngIf="subSection.fields && subSection.fields.length > 0">
                        <ng-container *ngFor="let field of subSection.fields; let i = index">
                            <ng-container *ngIf="!hideField(field, record) && field.show !== false">
                                <div class="inboundIntegrationFieldContainer">
                                    <ng-container *ngTemplateOutlet="integrationField; context: { record: record, field: field }"></ng-container>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </ng-template>

    <ng-template #httpStructure let-record="record" let-subSection="subSection" let-subSectionRecord="subSectionRecord">
        <ng-container [ngSwitch]="subSection.array">
            <div *ngSwitchCase="false">
                <div class="http-form-container w-full mt-2">
                    <div class="http-request-row flex w-full">
                        <div class="flex items-center w-full">
                            <!-- Method Selector with consistent height -->
                            <ng-container *ngFor="let field of subSection.fields">
                                <ng-container [ngSwitch]="field.uiType">
                                    <ng-container *ngSwitchCase="'HTTP-method'">
                                        <div class="method-container">
                                            <ng-container *ngTemplateOutlet="integrationField; context: { record: record, field: field, hide: hideField(field, record, undefined, subSection) }"></ng-container>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'HTTP-url'">
                                        <div class="url-container flex-grow h-full">
                                            <ng-container *ngTemplateOutlet="integrationField; context: { record: record, field: field, hide: hideField(field, record, undefined, subSection) }"></ng-container>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="subSection.hasChildSubSectons">
                    <ng-container *ngTemplateOutlet="subsectionsStructure; context: { record: record, subSections: subSection.childSubSections, subSectionRecord: subSectionRecord }"></ng-container>
                </ng-container>
            </div>
            <ng-container *ngSwitchDefault>Not yet implemented</ng-container>
        </ng-container>
    </ng-template>

    <ng-template #integrationField let-record="record" let-field="field" let-hide="hide" let-subSectionRecord="subSectionRecord">
        <app-integrations-field-template [readonly]="readonly" [ngClass]="{ 'w-full': field?.informationSnippetType?.length > 0}" [record]="record" [field]="field" [masterTableColumns]="masterTableColumns" [hide]="hide" [sources]="sources" [subSectionRecord]="subSectionRecord" [subTenants]="subTenants" [masterTables]="masterTables" (apiConfigChange)="apiConfigChange.emit({$event,subSectionRecord})" (configNameChanged)="configNameChanged.emit({$event, subSectionRecord})" (chainChanged)="chainChanged.emit({$event, field, subSectionRecord})" (transformationsChanged)="transformationsChanged.emit({$event, field, subSectionRecord})" (getMasterColumns)="getMasterColumns.emit($event)" (checkDisableUpdateAndRunNow)="checkDisableUpdateAndRunNow.emit($event)" [inConnectorsUI]="inConnectorsUI" (appChanged)="appChanged.emit($event)" (checkValidateButton)="checkValidateButton.emit($event)"></app-integrations-field-template>
        <ng-container *ngIf="field?.informationSnippetType?.length > 0 && !hideField(field, record, undefined, subSectionRecord) && field.show !== false">
            <ng-container [ngSwitch]="field.informationSnippetType" *transloco="let translate;">
                <ng-container *ngSwitchCase="'snippet'">
                    <div class="w-full inline-block rounded overflow-hidden shadow-sm border border-gray-200 p-0 mb-[18px]">
                        <div class="relative p-2 bg-gray-100 flex justify-between items-center">
                            <span class="font-medium"> {{translate('Information')}} </span>
                            <div class="flex items-center">
                                <material-button [buttonType]="'icon'" [size]="'small'" [prefixIcon]="'content_copy'" (buttonClicked)="copyToClipboard(field.information)" [titleText]="translate('Copy to clipboard')"></material-button>
                            </div>
                        </div>
                        <pre [innerHTML]="field.information" class="block p-3 bg-gray-50 font-mono text-sm overflow-x-auto min-h-[100px] max-h-[170px]"></pre>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'popup'">
                    <span class="inline-block align-middle ml-2">
                        <material-button [buttonType]="'icon'" [size]="'small'" [prefixIcon]="'info'" [titleText]="translate('View Information')" (buttonClicked)="field.showInfoPopup = !field.showInfoPopup"></material-button>
                    </span>
                    <div *ngIf="field.showInfoPopup"
                         class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
                         (click)="field.showInfoPopup = false">
                        <div class="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 overflow-hidden"
                             (click)="$event.stopPropagation()">
                            <div class="bg-gray-100 px-4 py-3 flex justify-between items-center border-b border-gray-200">
                                <h3 class="font-medium text-gray-700">{{translate('Information')}}</h3>
                                <div class="flex items-center space-x-2">
                                    <material-button [buttonType]="'icon'" [size]="'small'" [prefixIcon]="'content_copy'" (buttonClicked)="copyToClipboard(field.information)" [titleText]="translate('Copy to clipboard')"></material-button>
                                    <material-button [buttonType]="'icon'" [size]="'small'" [prefixIcon]="'close'" (buttonClicked)="field.showInfoPopup = false" [titleText]="translate('Close')"></material-button>
                                </div>
                            </div>
                            <div class="p-4 max-h-[70vh] overflow-auto">
                                <pre [innerHTML]="field.information" class="bg-gray-50 p-4 rounded font-mono text-sm overflow-x-auto border border-gray-200"></pre>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-template>

    <ng-template #subsectionsStructure let-subSections="subSections" let-record="record" let-subSectionRecord="subSectionRecord">
        <app-integration-sub-sections [readonly]="readonly" [subSections]="subSections" [record]="record" [subSectionRecord]="subSectionRecord" [inConnectorsUI]="inConnectorsUI" [sources]="sources" (appChanged)="appChanged.emit($event)" (chainChanged)="chainChanged.emit($event)" (transformationsChanged)="transformationsChanged.emit($event)" (checkValidateButton)="checkValidateButton.emit($event)"></app-integration-sub-sections>
    </ng-template>
</ng-container>
